import { Component, OnInit, Input, Output, EventEmitter, ElementRef, HostListener, forwardRef, ViewChild, Inject, Injector } from '@angular/core';
import { AbstractValueAccessor } from '../abastract-value-accesor';
import { NG_VALUE_ACCESSOR, NgControl, FormControl } from '@angular/forms';
import { MbValidationDirective } from '../directives/mb-validation.directive';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MbTurboInputComponent),
  multi: true
};

@Component({
  selector: 'app-mb-turbo-input',
  templateUrl: './mb-turbo-input.component.html',
  styleUrls: ['./mb-turbo-input.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class MbTurboInputComponent extends AbstractValueAccessor implements OnInit {

  @Input() title: string;
  @Input() placeholder: string;
  @Input() wrap: boolean;
  @Input() mini: boolean;
  @Input() rightItem: boolean;
  @Input() inputList: Array<any>;
  @Input() inputListId: string;
  @Input() remove: boolean;
  @Input() formControlName;
  @Output() itemRemoved: EventEmitter<any> = new EventEmitter<any>();
  validation: FormControl;
  o: boolean;
  value: any;
  searchValue = '';
  private onTouchedCallback: () => void;

  constructor(private injector: Injector, private eRef: ElementRef) {
    super();
  }

  ngOnInit() {
    this.validation = this.injector.get(NgControl);
  }

  @HostListener('document:click', ['$event.target'])
  public outsideClick(e) {
    if (!this.eRef.nativeElement.contains(e) && (this.o)) {
      this.o = !this.o;
    }
  }

  public toggle() {
    this.o = !this.o;
  }

  public set(selected) {
    this.value = selected;
    this.toggle();
  }

  public removeItem(e, item) {
    this.itemRemoved.emit(item);
    e.stopPropagation();
  }

  public search(e) {
    this.searchValue = e.path[0].value;
    if (e.charCode === 13) {
      this.toggle();
      e.preventDefault();
    }
  }

  onBlur() {
    this.onTouchedCallback();
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}
